//Import Services
import Services from '../core/services'

export default { 
  clearSelection() {
    return new Promise((resolve) => {
      return Services
        .get(`api/selections/selection/clearselection`)
        .then( ({data}) => {      
          if (data && data.success) {
            return resolve(null);  
          }

          return resolve(null);
        })
        .catch(() => {
          return resolve(null);
        }); 
    })
  },
  updateSelection( fieldData ) {
    return new Promise((resolve) => {
      return Services
        .post(`api/selections/selection/updateselection`, fieldData )      
        .then( ({data}) => {    
          if (data && data.success) {
            return resolve(data || null);  
          }

          return resolve(null);
        })
        .catch(() => {
          return resolve(null);
        }); 
    })
  },
  getDescriptions() {
    return new Promise((resolve) => {
      return Services
        .get(`api/selections/selection/getdescriptions`)
        .then( ({data}) => {      
          if (data && data.success) {
            return resolve(data.descriptions || null);  
          }

          return resolve(null);
        })
        .catch(() => {
          return resolve(null);
        }); 
    })
  }    
}